import {Table} from "antd";
import {ColumnProps} from "antd/lib/table";
import React, {FC, memo} from "react";
import {CourseLesson, EditCourseLessonInput, GetCourseLessonsByCourseIdQuery, NewCourseLessonInput, PaymentInterval} from "../../../../generated/graphql";
import i18n from "../../../../services/i18n";
import {renderAmount, renderDateAsWeekdayTag, renderDateFormatted, renderStartEndTime} from "../../../../views/TableColumnRenderers/TableColumnRenderers";
import css from "./CourseLessonPreviewTable.less";
import {sortByStartDateTime} from "../../../../helpers/sortingFunctions";
import {QueryItem} from "../../../../types";

type CourseLessonType = Pick<CourseLesson, "id" | "startDateTime" | "endDateTime" | "locationId">;

type CourseLessonPreviewTableProps = {
    // courseId: Course["id"];
    // courseLessons: Array<CourseLessonType>;
    courseLessons: Array<NewCourseLessonInput | EditCourseLessonInput>;
    totalPrice?: number;
    paymentInterval?: PaymentInterval;
    freePlaces?: number;
};

type GetCourseLessonsByCourseIdQueryItem = QueryItem<GetCourseLessonsByCourseIdQuery["courseLessonsByCourseId"]>;

type TableType = GetCourseLessonsByCourseIdQuery["courseLessonsByCourseId"]["0"];

const CourseLessonPreviewTable: FC<CourseLessonPreviewTableProps> = ({
    courseLessons,
    totalPrice,
    paymentInterval,
    // freePlaces,
}) => {
    // const {data, loading} = useGetCourseLessonsByCourseIdQuery({
    //     variables: {courseId},
    // });
    // const courseLessons: Array<GetCourseLessonsByCourseIdQueryItem> =
    //     data?.courseLessonsByCourseId ?? [];

    const pricePerLesson = totalPrice ? totalPrice / courseLessons.length : 0;

    const columns: Array<ColumnProps<TableType>> = [
        {
            title: "#",
            dataIndex: "number",
            render: (text, record, index) => index + 1,
        },
        {
            title: i18n.containers.courses.CourseCreate.courseStartDateTime.label(),
            dataIndex: "dayOfTheWeek",
            render: (text, record) =>
                renderDateAsWeekdayTag({
                    value: record.startDateTime,
                    style: {
                        width: "100%",
                        textAlign: "center",
                        fontWeight: 600,
                    },
                }),
        },
        {
            title: i18n.containers.courses.CourseCreate.courseStartDateTime.label(),
            dataIndex: "startDateTime",
            render: (text, record) => renderDateFormatted(record.startDateTime, "DD. MMM YYYY"),
            // defaultSortOrder: "descend",
            sorter: sortByStartDateTime,
            sortDirections: [],
            sortOrder: "ascend",
        },
        {
            title: i18n.containers.courses.CourseCreate.courseStartDateTime.label(),
            dataIndex: "times",
            render: (text, record) =>
                renderStartEndTime({
                    startTime: record.startDateTime,
                    endTime: record.endDateTime,
                }),
        },
        {
            title: i18n.containers.courses.CourseCreate.courseStartDateTime.label(),
            dataIndex: "lessonPrice",
            render: (text, record) => (paymentInterval === PaymentInterval.PerLesson ? renderAmount(pricePerLesson) : null),
        },
        // {
        //     title: i18n.containers.courses.CourseCreate.courseStartDateTime.label(),
        //     dataIndex: "freePlaces",
        //     render: (text, record) => renderFreePlaces(freePlaces ?? 0),
        // },
    ];

    return (
        <div className={css.root}>
            <Table<Array<NewCourseLessonInput | EditCourseLessonInput>>
                // loading={loading}
                showHeader={false}
                size="small"
                rowKey={(record, index) => (record as CourseLessonType).id ?? `${record.startDateTime ?? "lesson"}-${index}`}
                columns={columns}
                dataSource={courseLessons}
                pagination={courseLessons.length > 15 ? undefined : false}
            />
        </div>
    );
};

export default memo(CourseLessonPreviewTable);
